export const ENRICHMENT_TYPE = 'Enrichment' as const;
